import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function DownIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M14 8.24 8 14m0 0L2 8.24M8 14V2" /></svg>
  );
}

export default DownIcon;
